import React from 'react';
import { createRoot } from 'react-dom/client';
import { TaskflowGraphPanel } from './TaskflowGraphPanel';

export function registerTaskflowGraph(): void {
  document.querySelectorAll<HTMLElement>('[data-taskflow-graph]').forEach(container => {
    const textareaId = container.dataset.textareaId ?? '';
    if (!textareaId) {
      console.warn('[taskflow-graph] missing data-textarea-id');
      return;
    }
    createRoot(container).render(React.createElement(TaskflowGraphPanel, { textareaId }));
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', registerTaskflowGraph);
} else {
  registerTaskflowGraph();
}
